'use strict';

const { String, Boolean } = require('../lib/types');
const { make } = require('../lib/build-spec');

module.exports = {
    history: make(
        String,
        'history',
        'Historically, does the patient like to know everything about their health situation, even if it is bad news?'
    ),
    understandMedical: make(
        String,
        'understandMedical',
        'Does the patient understand their overall medical condition?'
    ),
    understandTreatment: make(
        String,
        'understandTreatment',
        'Does the patient understand their overall treatment plan?'
    ),
    happyWithCare: make(
        String,
        'happyWithCare',
        'Overall is the patient happy with their current medical care?'
    ),

    realisticPrognosis: make(
        String,
        'realisticPrognosis',
        'Does the patient have realistic expectations of their prognosis?'
    ),
    realisticTreatment: make(
        String,
        'realisticTreatment',
        'Does the patient have realistic expectations of their treatment?'
    ),
    realisticSymptoms: make(
        String,
        'realisticSymptoms',
        'Does the patient have realistic expectations of their symptom burden?'
    ),
    copingSkills: make(
        String,
        'copingSkills',
        'Does the patient have adequate coping skills?'
    ),
    longTerm: make(
        String,
        'longTerm',
        'Is there anticipation of long term care needs?'
    ),

    understandHospice: make(
        String,
        'culturalNeeds',
        'When clinically appropriate, does the patient want to understand more about hospice care?'
    ),
    arrangedFuneral: make(
        String,
        'arrangedFuneral',
        'Has the patient participated in pre-arranged funeral planning?'
    ),
    arrangedFuneralHelp: make(
        String,
        'arrangedFuneralHelp',
        'If the patient has not participated in pre-arranged funeral planning, would they like to?'
    ),

    housing: make(Boolean, 'housing', 'Housing'),
    SNF: make(Boolean, 'SNF', 'SNF'),
    DME: make(Boolean, 'DME', 'DME'),
    sitters: make(Boolean, 'sitters', 'Sitters')
};
